var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isShowLoadingScreen)?_c('header-view'):_vm._e(),_c('b-container',[_c('stepper-view',{attrs:{"steps":_vm.steps,"step":_vm.step}}),_c('router-view')],1),(!_vm.isShowLoadingScreen)?_c('footer-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }